// Utilidades de la sección «Contactos».

export const PLATAFORMAS = { whatsapp: 'WhatsApp', instagram: 'Instagram' };

export const nombreDe = (contacto) =>
  contacto.nombre
  || contacto.telefono
  || (contacto.whatsappUsername ? `@${contacto.whatsappUsername}` : `Chat ${contacto.chatId}`);

export const identificadorDe = (contacto) =>
  contacto.telefono || (contacto.whatsappUsername ? `@${contacto.whatsappUsername}` : '—');

export const inicialesDe = (contacto) => {
  const palabras = (contacto.nombre || '').trim().split(/\s+/).filter(Boolean);
  if (palabras.length > 0) {
    return palabras.slice(0, 2).map((p) => p[0].toUpperCase()).join('');
  }
  return contacto.whatsappUsername ? contacto.whatsappUsername[0].toUpperCase() : null;
};

export const TONOS = 6;

export const tonoDe = (chatId) => Math.abs(Number(chatId) || 0) % TONOS;

const CON_ZONA = /([zZ]|[+-]\d\d:\d\d)$/;

// El backend corre en UTC y serializa LocalDateTime sin zona.
const aFecha = (valor) => new Date(CON_ZONA.test(valor) ? valor : `${valor}Z`);

export const fechaLocal = (valor) => {
  if (!valor) return '—';
  return aFecha(valor).toLocaleString('es-ES');
};

const MINUTO = 60 * 1000;
const HORA = 60 * MINUTO;
const DIA = 24 * HORA;

export const haceCuanto = (valor, ahora = new Date()) => {
  if (!valor) return '—';
  const fecha = aFecha(valor);
  const diferencia = ahora - fecha;
  if (diferencia < MINUTO) return 'ahora';
  if (diferencia < HORA) return `hace ${Math.floor(diferencia / MINUTO)} min`;
  if (diferencia < DIA) return `hace ${Math.floor(diferencia / HORA)} h`;
  if (diferencia < 7 * DIA) return `hace ${Math.floor(diferencia / DIA)} d`;
  return fecha.toLocaleDateString('es-ES');
};

export const detalleDeError = (respuesta, respaldo) =>
  respuesta?.data?.detail || respuesta?.data?.error || respaldo;
